import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getBookingList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/bookings${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async exportBookingList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/bookings/export${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getBookingDetail(id) {
    const path = `/bookings/${id}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async approveBooking({ id }) {
    const path = `/bookings/${id}/approve`;

    const response = await axiosClient.put(path);

    return response.data;
  },

  async cancelBooking({ id }) {
    const path = `/bookings/${id}/cancel`;

    const response = await axiosClient.put(path);

    return response.data;
  },

  // method: 'ONEPAY' | 'MANUAL' (default MANUAL); gatewayRef only for MANUAL; note always
  // required by the modal, though BE accepts an empty body too (onepay-refund.md §6).
  async refundBooking({ id, method, gatewayRef, note }) {
    const path = `/bookings/${id}/refund`;

    const response = await axiosClient.put(path, { method, gatewayRef, note });

    return response.data;
  },

  // Re-push a failed/skipped Hotellink sync (docs/hotellink/booking-sync.md §4.3). Answers only
  // { _id, orderId, otaSync } — never otaBookingId, even on SYNCED — so the caller refetches the
  // full detail rather than merging this response into it.
  async otaSyncBooking({ id }) {
    const path = `/bookings/${id}/ota-sync`;

    const response = await axiosClient.post(path);

    return response.data;
  },

  async confirmBooking({ id, confirmBooking, values, callback, ...rest }) {
    const path = `/bookings/${id}/confirm-booking`;
    const body = values || (confirmBooking !== undefined ? { confirmBooking, ...rest } : rest);

    const response = await axiosClient.put(path, body);

    return response.data;
  },
};
